import * as React from "react";

import { Post } from "interfaces/wordpress";
import Card from "components/the-buzz-theme/card/card";
import { sliderOptions } from "components/the-buzz-theme/slider/slider-options";

const lexemes = {
  articleRelatedPostsTitle: "Related",
  articleRelatedPostsTitleScreenReader: " Articles",
};

export type Props = {
  categoryName?: string;
  relatedPosts?: Post[] | null;
};

export default function ArticleRelatedPosts({
  categoryName,
  relatedPosts,
}: Props) {
  React.useEffect(() => {
    // @ts-ignore
    const Swiper = global.window.Swiper;
    /* eslint-disable no-new */

    /* Cards - Mobile */
    /* eslint-disable no-new */
    const mobileSwiperList =
      Swiper && new Swiper(".swiper-mobile-container", sliderOptions.mobile);

    return () => {
      if (mobileSwiperList) {
        mobileSwiperList.map((mobileSwiper: any) => mobileSwiper.destroy());
      }
    };
  }, []);
  return (
    <>
      <div className="yarpp yarpp-related yarpp-related-website yarpp-template-yarpp-template-simple">
        <h2 id="related-posts" className="related-posts-title">
          {lexemes.articleRelatedPostsTitle}
          <span className="screen-reader-text">{categoryName}</span>
          <span className="screen-reader-text srt-mobile">
            {lexemes.articleRelatedPostsTitleScreenReader}
          </span>
        </h2>

        <div className="related-posts-container post-loop site-loop">
          <div className="swiper-mobile">
            <div className="swiper-mobile-container post-loop-container">
              <div className="swiper-wrapper">
                {relatedPosts &&
                  relatedPosts
                    .filter((_node, index) => index < 4)
                    // @ts-ignore
                    .map((post: Post, postKey: number) => (
                      <div className="swiper-slide" key={postKey}>
                        <Card post={post || undefined} />
                      </div>
                    ))}
              </div>
            </div>
          </div>

          {/* Regular Cards */}
          <div className="swiper-desktop">
            <ul aria-labelledby="related-posts" className="related-posts-list">
              {relatedPosts &&
                relatedPosts
                  .filter((_node, index) => index < 4)

                  .map((post: any, postKey: any) => (
                    <li key={postKey}>
                      <Card post={post || undefined} />
                    </li>
                  ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
